export const dashboardLocale = {
  welcomeToPanel: "Bienvenue dans le panneau d'administration !",
  useLeftMenu: 'Utilisez le menu burger pour gérer les utilisateurs',
  myBalance: 'Mon Solde',
  incomeForToday: "Revenus pour aujourd'hui",
  users: 'Utilisateurs',
  allUsers: 'Tous les utilisateurs',
  totalPlayers: 'Joueur totals',
  registeredToday: "Enregistré aujourd'hui",
  totalCashiers: 'Total des caissiers',
  totalAdmins: "Nombre total d'administrateurs",
  showInfo: 'Afficher les informations',
  today: "Aujourd'hui",
  yesterday: 'Hier',
  week: 'Semaine',
  month: 'Mois',
  or: 'ou',
  from: 'Depuis',
  to: 'À',
  show: 'Montrer',
  depositAndWithdrawal: 'Dépôt/Retrait',
  allTransfers: 'Tous les transferts',
  deposits: 'Dépôts',
  withdrawals: 'Retraits',
  total: 'Total',
  numberOfDeposits: 'Nombre de dépôts',
  numberOfWithdrawals: 'Nombre de retraits',
  bets: 'Paris',
  betsHistory: 'Historique des paris',
  numberOfBets: 'Nombre de paris',
  betHistory: 'Historique des paris',
};
